// src/utils/shareLink.js
// Shares a link to a track's public day-card page — Web Share API with a clipboard fallback,
// same pattern as Dashboard.js's handleShare/handleCopy, but for a URL rather than an image blob.
export async function shareTrackLink(dayNumber, stationName) {
  const url = `${window.location.origin}/day/${dayNumber}.html`
  const shareData = { title: stationName, text: `Track ${dayNumber} — ${stationName}`, url }

  if (navigator.share && (!navigator.canShare || navigator.canShare(shareData))) {
    try {
      await navigator.share(shareData)
      return { shared: true }
    } catch (err) {
      if (err?.name === 'AbortError') return { shared: false } // user cancelled
    }
  }

  await navigator.clipboard?.writeText(url)
  return { shared: false, copied: true }
}
